(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
const accordionItems = document.querySelectorAll('.accordion-item');

accordionItems.forEach(item => {
	const button = item.querySelector('dt button');
	const indicator = button.querySelector('.indicator');
	
	button.addEventListener('click', () => {
		const expanded = button.getAttribute('aria-expanded') === 'true';
		accordionItems.forEach(i => {
			const btn = i.querySelector('dt button');
			const ind = btn.querySelector('.indicator');
			btn.setAttribute('aria-expanded', false);
			i.querySelector('dd').classList.add('h-0', 'opacity-0', 'p-0');
			i.querySelector('dd').classList.remove('h-auto', 'opacity-100', 'p-5');
			indicator.innerHTML = `
			<svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
				<path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6"/>
			</svg>`;
		});
		
		if (! expanded) {
			button.setAttribute('aria-expanded', true);
			item.querySelector('dd').classList.remove('h-0', 'opacity-0', 'p-0');
			item.querySelector('dd').classList.add('h-auto', 'opacity-100', 'p-5');
			indicator.innerHTML = `
			<svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
				<path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6"/>
			</svg>`;
		}
		});
	});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
	if(enable_minmax_buys){
		_checkCartPageQuantities(mins, maxs);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const FAQcats = document.querySelector('ul.faq-cats');
    const FAQaccordion = document.querySelector('.accordion.faq');

    FAQcats.querySelectorAll('li').forEach(cat => {
      cat.addEventListener('click', () => {
        var currentActiveCat = FAQcats.querySelector('li.active');
        if (currentActiveCat) {
          currentActiveCat.classList.remove('active');
          cat.classList.add('active');
          updateFAQ();
        }
      });
    });

    function updateFAQ() {
      var activeCatItem = FAQcats.querySelector('li.active');
      if (activeCatItem) {
        var activeCat = activeCatItem.getAttribute('data-faq-tab');
        FAQaccordion.querySelectorAll('.accordion-item').forEach(item => {
          if (item.getAttribute('data-faq-category') == activeCat) {
            item.classList.remove('hidden');
          } else {
            item.classList.add('hidden');
          }
        });
      }
    }

    updateFAQ();

    var items = FAQaccordion.querySelectorAll('.accordion-item');
    items.forEach(item => {
      item.querySelector('.accordion-title').addEventListener('click', function (e) {
        updateFAQ();
        var activeItem = item.closest('.accordion').querySelector('.accordion-item.active');
        if (activeItem) {
          activeItem.classList.remove('active');
        }
        this.closest('.accordion-item').classList.add('active');
      });
    });    
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["features"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
const tabButtons = document.querySelectorAll('.tab-button');
const tabImages = document.querySelectorAll('.tab-image');
const tabContents = document.querySelectorAll('.tab-content');

function switchTab(targetTab) {
// Remove active class from all buttons
tabButtons.forEach(button => {
button.classList.remove('active');
button.classList.remove('bg-gradient-to-b', 'from-gray-800', 'to-gray-800/30', 'border-cyan-500/40');
button.classList.add('border-transparent');

const span = button.querySelector('span');
const icon = button.querySelector('.filter');
if (span) span.classList.add('text-white');
if (icon) icon.classList.add('brightness-0', 'invert');
});

// Hide all tab content
tabImages.forEach(image => image.classList.add('hidden'));
tabContents.forEach(content => content.classList.add('hidden'));

// Show target content
const targetImage = document.getElementById('image-' + targetTab);
const targetContent = document.getElementById('content-' + targetTab);
const targetButton = document.querySelector(`[data-tab="${targetTab}"]`);

if (targetImage) targetImage.classList.remove('hidden');
if (targetContent) targetContent.classList.remove('hidden');

if (targetButton) {
targetButton.classList.add('active', 'bg-gradient-to-b', 'from-gray-800', 'to-gray-800/30', 'border-cyan-500/40');
targetButton.classList.remove('border-transparent');

const span = targetButton.querySelector('span');
const icon = targetButton.querySelector('.filter');
if (span) span.classList.add('text-white');
if (icon) icon.classList.remove('brightness-0', 'invert');
}
}

// Add click event listeners
tabButtons.forEach(button => {
button.addEventListener('click', function() {
const targetTab = this.getAttribute('data-tab');
switchTab(targetTab);
});
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-cross-sell"] && !Shopify.designMode) return;
  try {
    
    var loadProductRecommendationsIntoSection = function() {
        // Look for an element with class 'product-recommendations'
        var productRecommendationsSection = document.querySelector(".product-cross-sells");

        if (productRecommendationsSection === null) { return; }


        // Build request URL
        var requestUrl = productRecommendationsSection.dataset.url;

        // Create request and submit it using Ajax
        var request = new XMLHttpRequest();

        request.open("GET", requestUrl);

        request.onload = function() {
            if (request.status >= 200 && request.status < 300 && request.response !== "") {
                var container = document.createElement("div");
                container.innerHTML = request.response;

                productRecommendationsSection.innerHTML = container.querySelector(".product-cross-sells").innerHTML;

                if(document.querySelector(".product-cross-sells").textContent.trim() === ""){
                    document.querySelector(".product-cross-sells").closest('section').remove();
                } else {
                    window.initSlider(document.querySelector('.cross-sell-slider'), 1, 'section');
                    window.globalQuickView();
                }

            }else{
                window.initSlider(document.querySelector('.cross-sell-slider'), 1, 'section');
            }
        };

        request.send();
    };
    // If your section has theme settings, the theme editor
    // reloads the section as you edit those settings. When that happens, the
    // recommendations need to be fetched again.
    // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
    document.addEventListener("shopify:section:load", function(event) {
        if (event.detail.sectionId === "product-cross-sell") {
            loadProductRecommendationsIntoSection();
        }
    });

    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"] && !Shopify.designMode) return;
  try {
    
					document.addEventListener('DOMContentLoaded', function () {
					const productHeroAccordion = document.querySelector('.accordion.product-hero-accordion');
					productHeroAccordion.querySelectorAll('.accordion-item').forEach(item => {
					item.querySelector('.accordion-title').addEventListener('click', function (e) {
					var clickedItem = this.closest('.accordion-item');
					var isActive = clickedItem.classList.contains('active');
					var activeItem = item.closest('.accordion').querySelector('.accordion-item.active');
					if (activeItem) {
					activeItem.classList.remove('active');
					}
					if (!isActive) {
					clickedItem.classList.add('active');
					}
					});
					});
					});
					
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
	// Look for an element with class 'product-recommendations'
	var productRecommendationsSection = document.querySelector(".product-recommendations");
	
	if (productRecommendationsSection === null) { return; }
	
	
	// Build request URL
	var requestUrl = productRecommendationsSection.dataset.url;
	
	// Create request and submit it using Ajax
	var request = new XMLHttpRequest();
	
	request.open("GET", requestUrl);
	
	request.onload = function() {
		if (request.status >= 200 && request.status < 300) {
			var container = document.createElement("div");
			container.innerHTML = request.response;
			productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
			window.initSlider(document.querySelector('.related-slider'), 1, 'section');
		}
	};
	
	request.send();
};

document.addEventListener("shopify:section:load", function(event) {
	if (event.detail.sectionId === "product-recommendations") {
		loadProductRecommendationsIntoSection();
	}
});

loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
